import React, { FC } from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import {
  HighlightedHeader,
  Heading,
} from '@edreamsodigeo/prisma-design-system';

const HighlightedMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <Heading type="5" weight="medium" color="primary.90">
      {t('campaign.airline.text')}
    </Heading>
  );
};

const AirlineCampaignHeaderRevamp: FC = () => (
  <HighlightedHeader
    type="promotional"
    size="full"
    sx={{
      paddingBottom: 'small',
    }}
  >
    <HighlightedMessage />
  </HighlightedHeader>
);

export default AirlineCampaignHeaderRevamp;
